<template>
  <nav class="navbar">
    <div class="navbar-container">
      <div class="logo-container">
        <img 
          src="@/assets/logo/kurpot-logo-d.svg" 
          alt="Shower Santonic Logo" 
          class="logo"
        />
      </div>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBars'
}
</script>

<style scoped>
.navbar {
  width: 100%;
  background-color: #ffffff;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
}

.navbar-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo-container {
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo {
  height: 40px;
  width: auto;
}
</style>